import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';

export const VinHeartTrackingMap = {
  vin_sign_up_progress: TrackingEvent.actionStart(TrackingConstant.ACTION_SIGN_UP, TrackingConstant.BEGIN_SIGN_UP),
  vin_save_vehicle: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.SAVE_VIN),
  vin_unsave_vehicle: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.UNSAVE_VIN),
  inventory_heart_tooltip_link: TrackingEvent.actionCompleted(
    TrackingConstant.ACCESS_MY_ACCOUNT,
    TrackingConstant.ACCESS_MY_ACCOUNT
  ),
};
